import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Summary } from '@components';
import { iCourtFormValues, getSummaryScreen } from '@services/CourtService';

function CourtStep10(): ReactElement {
  const { values }: { values: iCourtFormValues } = useFormikContext();
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}

export default CourtStep10;
